import React, { useEffect, useState } from 'react'

function Career(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [show_accountant_full, set_show_accountant_full] = useState(false)
  const [show_assistant_full, set_show_assistant_full] = useState(false)
  const [show_bookkeeper_full, set_show_bookkeeper_full] = useState(false)
  const [show_customerservice_full, set_show_customerservice_full] =
    useState(false)
  const [show_developer_full, set_show_developer_full] = useState(false)
  const [show_trainer_full, set_show_trainer_full] = useState(false)
  const [show_salesrepresentative_full, set_show_salesrepresentative_full] =
    useState(false)

  const click_read_more = (e, job_type, action) => {
    e.preventDefault()
    switch (job_type) {
      case 'accountant':
        action === 'expand'
          ? set_show_accountant_full(true)
          : set_show_accountant_full(false)
        break
      case 'assistant':
        action === 'expand'
          ? set_show_assistant_full(true)
          : set_show_assistant_full(false)
        break
      case 'bookkeeper':
        action === 'expand'
          ? set_show_bookkeeper_full(true)
          : set_show_bookkeeper_full(false)
        break
      case 'customerservice':
        action === 'expand'
          ? set_show_customerservice_full(true)
          : set_show_customerservice_full(false)
        break
      case 'developer':
        action === 'expand'
          ? set_show_developer_full(true)
          : set_show_developer_full(false)
        break
      case 'trainer':
        action === 'expand'
          ? set_show_trainer_full(true)
          : set_show_trainer_full(false)
        break
      case 'salesrepresentative':
        action === 'expand'
          ? set_show_salesrepresentative_full(true)
          : set_show_salesrepresentative_full(false)
        break
      default:
        break
    }
  }
  const click_email = (e) => {
    e.preventDefault()
    window.location.href = 'mailto:BecomeFamily@RoadJockeyJA.com'
  }

  return (
    <div className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}>
      <div className="main-wrapper inner--page">
        <section
          className="hero-banner inner-banner center-bg"
          style={{ backgroundImage: `url('images/aboutus-banner.png')` }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="partner-banner-content">
                  <h1>Careers</h1>
                  <text>
                    Join and Grow with us and make an impect on
                    <br />
                    the world with your inspiring work
                  </text>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="aboutus-sec">
          <div className="container pb-5">
            <div className="row">
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/careers_page/staff_1.jpg"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">Join the RoadJockey Family</h3>
                  <label>
                    We are always interested in growing our family of experts
                    and professional support staff. If you are interested in
                    applying for any of the open positions on our team, please
                    feel free to submit your CV to our email
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      {' '}
                      BecomeFamily@RoadJockeyJA.com
                    </span>{' '}
                    or use the contact page. <br />
                    Even if we have no current openings, we will add your resume
                    to our candidate pool. We look forward to hearing from you!
                  </label>
                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/careers_page/about.jpg"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">Merchant Success Coordinator </h3>

                  {show_salesrepresentative_full ? (
                    <div className="div_full_content">
                      <label>
                        Job Summary: As a Merchant Success Coordinator, you will
                        play a crucial role in driving the growth of our digital
                        delivery platform by bringing new restaurants on board.
                        <br />
                        <br />
                        You will be responsible for identifying and engaging
                        with potential restaurant partners, showcasing the
                        benefits of our platform, and facilitating the sign-up
                        process.
                        <br />
                        <br />
                        Your efforts will contribute to expanding our network of
                        restaurants and ensuring a diverse and high-quality
                        dining experience for our customers.
                      </label>

                      <h5 className="mt-3">Responsibilities</h5>
                      <ul>
                        <li>
                          Identify and Prospect Restaurants: Actively research
                          and identify potential restaurants suitable for our
                          digital delivery platform. <br />
                          This includes leveraging online directories, local
                          listings, industry contacts, and other relevant
                          sources.
                        </li>
                        <li>
                          Build and Maintain Relationships: Establish and
                          maintain strong relationships with restaurant owners,
                          managers, and decision-makers.
                          <br />
                          Communicate the benefits and advantages of partnering
                          with our platform, addressing any questions or
                          concerns, and building rapport with potential
                          partners.
                        </li>
                        <li>
                          Present Platform Value Proposition: Conduct persuasive
                          and informative presentations to restaurant owners,
                          highlighting the features, benefits, and competitive
                          advantages of our digital delivery platform. <br />
                          Tailor the presentation to address the unique needs
                          and preferences of each restaurant.
                        </li>
                        <li>
                          Negotiate and Close Deals: Negotiate partnership
                          agreements and terms with potential restaurant
                          partners.
                          <br />
                          Collaborate with internal stakeholders, such as legal
                          and operations teams, to finalize contracts and ensure
                          a smooth onboarding process.
                        </li>
                        <li>
                          Coordinate Onboarding Process: Collaborate with the
                          onboarding team to ensure a seamless transition for
                          new restaurant partners. <br />
                          Provide necessary documentation, assist with menu
                          integration, and communicate any specific requirements
                          or preferences from the restaurant.
                        </li>
                        <li>
                          Monitor Performance and Provide Support: Regularly
                          monitor the performance of signed-up restaurants,
                          addressing any concerns or issues that arise. <br />
                          Act as the primary point of contact for restaurant
                          partners, providing ongoing support, answering
                          queries, and ensuring their satisfaction with our
                          services.
                        </li>
                        <li>
                          Market Research and Competitive Analysis: Continuously
                          stay updated on the local restaurant landscape,
                          industry trends, and competitor activities. <br />
                          Provide insights and suggestions to the management
                          team based on market research to enhance our
                          restaurant acquisition strategy.
                        </li>
                      </ul>

                      <h5 className="mt-3">Qualifications</h5>
                      <ul>
                        <li>
                          Strong negotiation and communication skills, with the
                          ability to articulate complex ideas effectively
                        </li>
                        <li>
                          Ability to build and maintain professional
                          relationships with diverse stakeholders
                        </li>
                        <li>
                          Self-motivated, target-driven, and results-oriented
                          mindset
                        </li>
                        <li>
                          Familiarity with the digital delivery industry and
                          understanding of the challenges and opportunities it
                          presents
                        </li>
                        <li>
                          Excellent organizational and time management skills,
                          with the ability to handle multiple tasks
                          simultaneously
                        </li>
                        <li>
                          Flexibility to work irregular hours, including
                          evenings and weekends, as required for restaurant
                          engagement activities
                        </li>
                      </ul>

                      <label className="mt-3">
                        Join our team as a Merchant Coordinator and be part of
                        our mission to revolutionize the way people experience
                        dining through our digital delivery platform.
                        <br />
                        <br />
                        Together, we will bring the best restaurants on board
                        and deliver outstanding culinary experiences to
                        customers across the region.
                      </label>

                      <div className="text-right">
                        <span
                          className="span_read_short"
                          onClick={(event) =>
                            click_read_more(
                              event,
                              'salesrepresentative',
                              'collapse',
                            )
                          }
                        >
                          Read Short...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="div_simple_content">
                      <label>
                        Job Summary: As a Merchant Success Coordinator, you will
                        play a crucial role in driving the growth of our digital
                        delivery platform by bringing new restaurants on board.
                        <br />
                        <br />
                        You will be responsible for identifying and engaging
                        with potential restaurant partners, showcasing the
                        benefits of our platform, and facilitating the sign-up
                        process.
                        <br />
                        <br />
                        Your efforts will contribute to expanding our network of
                        restaurants and ensuring a diverse and high-quality
                        dining experience for our customers.
                      </label>
                      <div className="text-right">
                        <span
                          className="span_read_more"
                          onClick={(event) =>
                            click_read_more(
                              event,
                              'salesrepresentative',
                              'expand',
                            )
                          }
                        >
                          Read More...
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-3">
                    <h5>Apply at:</h5>
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      BecomeFamily@RoadJockeyJA.com
                    </span>
                    <br />
                    <span className="ml-4">
                      Please ensure you put the job title on the subject line.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">(Remote) Customer Service Agent</h3>

                  {show_customerservice_full ? (
                    <div className="div_full_content">
                      <label>
                        Company Description: We are a leading digital delivery
                        company that connects customers with their favorite
                        restaurants and businesses. <br />
                        <br />
                        We provide a seamless ordering and delivery experience,
                        and we&apos;re dedicated to delivering outstanding
                        customer service. <br />
                        <br />
                        We are currently seeking remote Customer Service Agents
                        to join our team and assist customers in resolving
                        inquiries and providing exceptional support. <br />
                        <br />
                        <br />
                        Job Summary: As a Remote Customer Service Agent, you
                        will be the first point of contact for our customers,
                        addressing their inquiries, resolving issues, and
                        providing support.
                        <br />
                        <br />
                        Your primary goal will be to ensure customer
                        satisfaction and maintain a positive brand image.
                        <br />
                        <br />
                        This is a remote position, allowing you to work from the
                        comfort of your own home while still making a
                        significant impact on our customers&apos; experience.
                      </label>

                      <h5 className="mt-3">Responsibilities:</h5>
                      <ul>
                        <li>
                          Respond promptly and professionally to customer
                          inquiries through various communication channels,
                          including phone, email, and chat.
                        </li>
                        <li>
                          Provide accurate and comprehensive information about
                          our digital delivery services, order status, delivery
                          times, and other customer-related queries.
                        </li>
                        <li>
                          Resolve customer issues, complaints, or concerns by
                          investigating problems, identifying root causes, and
                          implementing appropriate solutions.
                        </li>
                        <li>
                          Escalate complex or unresolved issues to the
                          appropriate departments or higher-level support for
                          further assistance.
                        </li>
                        <li>
                          Maintain a high level of product knowledge to
                          effectively address customer inquiries and provide
                          accurate information.
                        </li>
                        <li>
                          Document customer interactions, inquiries, and
                          resolutions accurately in the customer service system
                          or CRM.
                        </li>
                        <li>
                          Demonstrate empathy, patience, and understanding in
                          all customer interactions, ensuring a positive
                          customer experience.
                        </li>
                        <li>
                          Identify and escalate trends, recurring issues, or
                          areas for improvement to the Customer Service Manager
                          for proactive resolution.
                        </li>
                        <li>
                          Stay up to date with company policies, procedures, and
                          updates regarding our digital delivery platform.
                        </li>
                        <li>
                          Collaborate with cross-functional teams, including
                          operations, logistics, and technical support, to
                          address customer needs and provide seamless service.
                        </li>
                      </ul>

                      <h5 className="mt-3">Qualifications:</h5>
                      <ul>
                        <li>
                          Previous customer service experience, preferably in a
                          remote or call center environment.
                        </li>
                        <li>
                          Excellent verbal and written communication skills,
                          with a strong command of the English language.
                        </li>
                        <li>
                          Proficient computer skills, including Microsoft
                          products, CRM systems, and communication tools.
                        </li>
                        <li>
                          Ability to multitask, prioritize, and manage time
                          effectively in a remote work setting.
                        </li>
                        <li>
                          Strong problem-solving skills with the ability to
                          think critically and find creative solutions.
                        </li>
                        <li>
                          Exceptional interpersonal skills and ability to build
                          rapport with customers from various backgrounds.
                        </li>
                        <li>
                          Empathy and patience when dealing with customer
                          concerns and complaints.
                        </li>
                        <li>
                          Self-motivated and able to work independently with
                          minimal supervision.
                        </li>
                        <li>
                          Flexibility to work various shifts, including
                          evenings, weekends, and holidays, to accommodate
                          customer service coverage.
                        </li>
                      </ul>

                      <label className="mt-3">
                        Join our remote Customer Service Agent team and play a
                        vital role in delivering exceptional customer
                        experiences for our digital delivery platform.
                        <br />
                        <br />
                        Work from the comfort of your own home, engage with
                        customers, and be part of a collaborative and supportive
                        team environment.
                        <br />
                        <br />
                        Apply now to become a part of our customer-centric
                        company!
                      </label>

                      <div className="text-right">
                        <span
                          className="span_read_short"
                          onClick={(event) =>
                            click_read_more(
                              event,
                              'customerservice',
                              'collapse',
                            )
                          }
                        >
                          Read Short...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="div_simple_content">
                      <label>
                        Company Description: We are a leading digital delivery
                        company that connects customers with their favorite
                        restaurants and businesses. <br />
                        <br />
                        We provide a seamless ordering and delivery experience,
                        and we&apos;re dedicated to delivering outstanding
                        customer service. <br />
                        <br />
                        Job Summary: As a Remote Customer Service Agent, you
                        will be the first point of contact for our customers,
                        addressing their inquiries, resolving issues, and
                        providing support. <br />
                        <br />
                        <br />
                      </label>
                      <div className="text-right">
                        <span
                          className="span_read_more"
                          onClick={(event) =>
                            click_read_more(event, 'customerservice', 'expand')
                          }
                        >
                          Read More...
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-3">
                    <h5>Apply at:</h5>
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      BecomeFamily@RoadJockeyJA.com
                    </span>
                    <br />
                    <span className="ml-4">
                      Please ensure you put the job title on the subject line.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/careers_page/contact.jpg"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/careers_page/developer.jpg"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">System Administrator</h3>

                  {show_developer_full ? (
                    <div className="div_full_content">
                      <label>
                        Company Description: We are a leading technology company
                        specializing in providing innovative solutions to
                        businesses of all sizes.
                        <br />
                        <br />
                        With a strong focus on Microsoft products and services,
                        we empower organizations to leverage cutting-edge
                        technologies and optimize their IT infrastructure.
                        <br />
                        <br />
                        We are seeking a talented and experienced System
                        Administrator who specializes in Microsoft products to
                        join our dynamic team.
                        <br />
                        <br />
                        <br />
                        Job Summary: As a System Administrator, you will play a
                        crucial role in managing and maintaining our Road
                        Jockey’s IT systems and infrastructure.
                        <br />
                        <br />
                        Your primary focus will be on designing, implementing,
                        and supporting Microsoft-based solutions, ensuring the
                        highest levels of system availability, security, and
                        performance.
                        <br />
                        <br />
                        You will collaborate closely with our clients, providing
                        expert guidance and support, and ensuring that their
                        technology needs are met efficiently and effectively.
                      </label>

                      <h5 className="mt-3">Responsibilities:</h5>
                      <ul>
                        <li>
                          Perform system administration tasks such as user
                          management, security management, system monitoring,
                          backup and recovery, and performance optimization.
                        </li>
                        <li>
                          Troubleshoot and resolve issues related to Microsoft
                          products and services, ensuring timely resolution and
                          minimizing downtime.
                        </li>
                        <li>
                          Collaborate with clients to understand their business
                          requirements and provide tailored solutions using
                          Microsoft technologies.
                        </li>
                        <li>
                          Plan and execute system upgrades, patches, and
                          migrations, ensuring minimal disruption to business
                          operations.
                        </li>
                        <li>
                          Monitor system performance, analyze system logs, and
                          implement proactive measures to optimize performance
                          and ensure data integrity.
                        </li>
                        <li>
                          Implement and enforce IT security policies and
                          procedures, including access controls, data
                          protection, and disaster recovery plans.
                        </li>
                        <li>
                          Provide end-user support, including troubleshooting
                          software and hardware issues related to Microsoft
                          products.
                        </li>
                        <li>
                          Stay updated on emerging Microsoft technologies, best
                          practices, and industry trends, and provide
                          recommendations for system improvements and
                          enhancements.
                        </li>
                        <li>
                          Document system configurations, procedures, and
                          troubleshooting steps for knowledge sharing and
                          reference purposes.
                        </li>
                      </ul>

                      <h5 className="mt-3">Qualifications:</h5>
                      <ul>
                        <li>
                          Minimum of 3 years of experience as a System
                          Administrator, with a strong focus on Microsoft
                          products and technologies.
                        </li>
                        <li>
                          Strong troubleshooting and problem-solving skills,
                          with the ability to analyze and resolve complex
                          technical issues.
                        </li>
                        <li>
                          Experience with system monitoring and performance
                          tuning tools.
                        </li>
                        <li>
                          Familiarity with IT security principles and best
                          practices, including access controls and data
                          protection.
                        </li>
                        <li>
                          Excellent communication skills, both verbal and
                          written, with the ability to effectively interact with
                          clients and technical teams.
                        </li>
                        <li>
                          Strong organizational skills, with the ability to
                          prioritize tasks and meet deadlines in a fast-paced
                          environment.
                        </li>
                      </ul>

                      <label className="mt-3">
                        Join our team and be part of an exciting journey to
                        deliver cutting-edge Microsoft-based solutions to our
                        clients.
                        <br />
                        <br />
                        As a System Administrator, you will have the opportunity
                        to showcase your expertise, collaborate with a talented
                        team, and make a significant impact on the success of
                        our clients&apos; IT infrastructure.
                        <br />
                        <br />
                        Apply now and let&apos;s shape the future of technology
                        together.
                      </label>

                      <div className="text-right">
                        <span
                          className="span_read_short"
                          onClick={(event) =>
                            click_read_more(event, 'developer', 'collapse')
                          }
                        >
                          Read Short...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="div_simple_content">
                      <label>
                        Company Description: We are a leading technology company
                        specializing in providing innovative solutions to
                        businesses of all sizes.
                        <br />
                        <br />
                        With a strong focus on Microsoft products and services,
                        we empower organizations to leverage cutting-edge
                        technologies and optimize their IT infrastructure.
                        <br />
                        <br />
                        <br />
                        Job Summary: As a System Administrator, you will play a
                        crucial role in managing and maintaining our Road
                        Jockey’s IT systems and infrastructure.
                        <br />
                        <br />
                      </label>

                      <div className="text-right">
                        <span
                          className="span_read_more"
                          onClick={(event) =>
                            click_read_more(event, 'developer', 'expand')
                          }
                        >
                          Read More...
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-3">
                    <h5>Apply at:</h5>
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      BecomeFamily@RoadJockeyJA.com
                    </span>
                    <br />
                    <span className="ml-4">
                      Please ensure you put the job title on the subject line.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">
                    Independent Delivery Driver (Roadie) Supervisor
                  </h3>

                  {show_trainer_full ? (
                    <div className="div_full_content">
                      <label>
                        Job Summary: As the Roadie Supervisor you will be
                        responsible for managing and overseeing the performance
                        of our team of independent delivery Roadies within our
                        digital delivery system.
                        <br />
                        <br />
                        You will ensure the smooth and efficient operations of
                        our delivery services by providing guidance, support,
                        and coordination to the Roadies.
                        <br />
                        <br />
                        Your role will involve managing Roadie schedules,
                        monitoring performance metrics, addressing Roadie
                        concerns, and fostering a positive and productive work
                        environment.
                      </label>

                      <h5 className="mt-3">Responsibilities:</h5>
                      <ul>
                        <li>
                          Roadie Management: Recruit, train, and onboard
                          independent delivery Roadies in accordance with
                          company policies and procedures. <br />
                          Assign Roadies to specific shifts and delivery zones,
                          considering factors such as Roadie availability,
                          workload, and geographic coverage.
                        </li>
                        <li>
                          Performance Monitoring: Monitor and evaluate Roadie
                          performance based on key performance indicators
                          (KPIs), such as on-time delivery, customer
                          satisfaction, and order accuracy. <br />
                          Identify areas for improvement and develop strategies
                          to enhance Roadie performance and productivity.
                        </li>
                        <li>
                          Roadie Support and Communication: Serve as the main
                          point of contact for Roadies, providing ongoing
                          support, guidance, and addressing any concerns or
                          issues that arise. <br />
                          Foster open lines of communication with Roadies,
                          ensuring they have the necessary resources and
                          information to perform their duties effectively.
                        </li>
                        <li>
                          Schedule Management: Create and maintain Roadie
                          schedules, taking into account Roadie availability,
                          peak delivery times, and business needs.
                          <br />
                          Efficiently allocate Roadies to maximize coverage and
                          minimize delivery times while adhering to operational
                          constraints and company guidelines.
                        </li>
                        <li>
                          Quality Control: Implement and enforce quality control
                          measures to ensure that Roadies adhere to delivery
                          protocols, food safety regulations, and customer
                          service standards.
                          <br />
                          Conduct periodic audits and spot checks to verify
                          compliance and identify areas for improvement.
                        </li>
                        <li>
                          Training and Development: Coordinate training sessions
                          and workshops to enhance Roadie skills, knowledge, and
                          customer service capabilities.
                          <br />
                          Keep Roadies informed about updates to delivery
                          procedures, system enhancements, and any relevant
                          policy changes.
                        </li>
                        <li>
                          Performance Feedback and Recognition: Provide regular
                          feedback and performance evaluations to Roadies,
                          recognizing outstanding performance and addressing
                          areas that require improvement. <br />
                          Implement Roadie recognition programs to motivate and
                          incentivize exceptional performance.
                        </li>
                        <li>
                          Crisis and Incident Management: Act as the main point
                          of contact for Roadies in case of accidents,
                          incidents, or emergencies during deliveries. <br />
                          Collaborate with relevant stakeholders, such as
                          insurance providers and law enforcement, to ensure
                          appropriate responses and resolutions.
                        </li>
                      </ul>

                      <h5 className="mt-3">Qualifications:</h5>
                      <ul>
                        <li>
                          Excellent leadership and interpersonal skills, with
                          the ability to motivate and manage a diverse team of
                          independent Roadies
                        </li>
                        <li>
                          Strong organizational and problem-solving abilities,
                          with attention to detail and the ability to multitask
                          effectively
                        </li>
                        <li>
                          Knowledge of delivery logistics, route optimization,
                          and familiarity with mapping/navigation tools
                        </li>
                        <li>
                          Understanding of food safety regulations and best
                          practices related to delivery services
                        </li>
                        <li>
                          Proficiency in using technology platforms and apps
                          used for delivery management and tracking
                        </li>
                        <li>
                          Ability to handle high-pressure situations and make
                          decisions quickly and effectively
                        </li>
                        <li>
                          Excellent communication skills, both verbal and
                          written
                        </li>
                        <li>
                          Flexibility to work in shifts, including evenings,
                          weekends, and holidays, as required by the business
                          needs
                        </li>
                      </ul>

                      <label className="mt-3">
                        Join our team as a Supervisor of Independent Delivery
                        Roadies and be at the forefront of managing and
                        optimizing our delivery operations.
                        <br />
                        <br />
                        Together, we will ensure that our customers receive
                        exceptional service while maintaining a motivated and
                        efficient team of independent Roadies.
                      </label>
                      <div className="text-right">
                        <span
                          className="span_read_short"
                          onClick={(event) =>
                            click_read_more(event, 'trainer', 'collapse')
                          }
                        >
                          Read Short...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="div_simple_content">
                      <label>
                        Job Summary: As the Roadie Supervisor you will be
                        responsible for managing and overseeing the performance
                        of our team of independent delivery Roadies within our
                        digital delivery system.
                        <br />
                        <br />
                        You will ensure the smooth and efficient operations of
                        our delivery services by providing guidance, support,
                        and coordination to the Roadies.
                        <br />
                        <br />
                        Your role will involve managing Roadie schedules,
                        monitoring performance metrics, addressing Roadie
                        concerns, and fostering a positive and productive work
                        environment.
                      </label>
                      <div className="text-right">
                        <span
                          className="span_read_more"
                          onClick={(event) =>
                            click_read_more(event, 'trainer', 'expand')
                          }
                        >
                          Read More...
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-3">
                    <h5>Apply at:</h5>
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      BecomeFamily@RoadJockeyJA.com
                    </span>
                    <br />
                    <span className="ml-4">
                      Please ensure you put the job title on the subject line.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/careers_page/trainer.jpg"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              <div className="col-sm-5">
                <div className="p-3 mt-5">
                  <img
                    src="images/rider-banner.png"
                    style={{ width: '100%' }}
                  />
                </div>
              </div>
              <div className="col-sm-7 text-center_ benefit-content">
                <div className="mt-5">
                  <h3 className="mb-4">
                    Independent Delivery Driver (With Own Vehicle) - Flexible
                    Deliveries
                  </h3>

                  {show_bookkeeper_full ? (
                    <div className="div_full_content">
                      <label>
                        Company Description: We are a leading digital delivery
                        platform, connecting customers with their favorite
                        restaurants and businesses. <br />
                        <br />
                        We are expanding our delivery network and are seeking
                        motivated and reliable independent delivery drivers with
                        their own vehicle to join our team. <br />
                        <br />
                        If you&apos;re looking for flexible work opportunities
                        and enjoy being on the road, this is the perfect job for
                        you.
                        <br />
                        <br />
                        <br />
                        Job Summary: As an Independent Delivery Driver with your
                        own vehicle, you will play a vital role in ensuring
                        timely and efficient deliveries to our valued customers.
                        <br />
                        <br />
                        You will have the freedom to choose your own working
                        hours and take advantage of flexible shifts that fit
                        your schedule.
                        <br />
                        <br />
                        Join our dynamic team and become an essential part of
                        our mission to provide exceptional delivery services.
                      </label>

                      <h5 className="mt-3">Responsibilities:</h5>
                      <ul>
                        <li>
                          Accept and fulfill delivery orders based on your
                          availability and within designated delivery zones.
                        </li>
                        <li>
                          Maintain a professional and customer-focused attitude
                          during all interactions with customers and restaurant
                          staff.
                        </li>
                        <li>
                          Handle food and packages with care, ensuring their
                          safe delivery and presentation to customers.
                        </li>
                        <li>
                          Follow delivery instructions, special requests, and
                          any additional delivery-related guidelines provided by
                          the platform and participating businesses.
                        </li>
                        <li>
                          Use the provided delivery app or device to track
                          orders, update delivery statuses, and maintain
                          accurate records of deliveries.
                        </li>
                        <li>
                          Maintain your vehicle in good working condition and
                          ensure it meets all necessary safety and maintenance
                          standards.
                        </li>
                        <li>
                          Communicate any delivery-related issues, such as
                          delays or address discrepancies, promptly to the
                          support team.
                        </li>
                        <li>
                          Adhere to traffic laws, regulations, and safe driving
                          practices at all times.
                        </li>
                        <li>
                          Provide excellent customer service by addressing any
                          delivery-related concerns and striving to exceed
                          customer expectations.
                        </li>
                      </ul>

                      <h5 className="mt-3">Qualifications:</h5>
                      <ul>
                        <li>
                          Must have a valid driver&apos;s license and a reliable
                          vehicle (car or motorcycle) with appropriate insurance
                          coverage.
                        </li>
                        <li>
                          Prior experience as a delivery driver or in a similar
                          role is preferred, but not mandatory.
                        </li>
                        <li>
                          Excellent time management skills with the ability to
                          prioritize deliveries effectively.
                        </li>
                        <li>
                          Strong communication and interpersonal skills to
                          interact with customers and handle delivery-related
                          inquiries or issues.
                        </li>
                        <li>
                          Familiarity with the local area and ability to
                          navigate efficiently using maps or GPS.
                        </li>
                        <li>
                          Availability to work flexible hours, including
                          evenings, weekends, and holidays.
                        </li>
                        <li>
                          Ability to handle a fast-paced work environment and
                          meet delivery targets.
                        </li>
                        <li>
                          Possess a responsible and safety-conscious mindset.
                        </li>
                        <li>
                          Physical fitness and the ability to lift and carry
                          packages up to a certain weight limit.
                        </li>
                      </ul>

                      <div className="text-right">
                        <span
                          className="span_read_short"
                          onClick={(event) =>
                            click_read_more(event, 'bookkeeper', 'collapse')
                          }
                        >
                          Read Short...
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="div_simple_content">
                      <label>
                        Company Description: We are a leading digital delivery
                        platform, connecting customers with their favorite
                        restaurants and businesses. <br />
                        <br />
                        We are expanding our delivery network and are seeking
                        motivated and reliable independent delivery drivers with
                        their own vehicle to join our team.
                        <br />
                        <br />
                        <br />
                        Job Summary: As an Independent Delivery Driver with your
                        own vehicle, you will play a vital role in ensuring
                        timely and efficient deliveries to our valued customers.
                      </label>
                      <div className="text-right">
                        <span
                          className="span_read_more"
                          onClick={(event) =>
                            click_read_more(event, 'bookkeeper', 'expand')
                          }
                        >
                          Read More...
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="mt-3">
                    <h5>Apply at:</h5>
                    <span
                      className="span_apply ml-4"
                      onClick={(event) => click_email(event)}
                    >
                      BecomeFamily@RoadJockeyJA.com
                    </span>
                    <br />
                    <span className="ml-4">
                      Please ensure you put the job title on the subject line.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </section>
      </div>
    </div>
  )
}

export default Career
